import React from 'react';

interface IconThreeDiamondsProps {
  color?: string;
  size?: string;
  className?: string;
}

export const ThreeDiamondsIcon = ({ color, className }: IconThreeDiamondsProps) => (
  <span className={`inline-flex items-center gap-[1px] text-[5px] whitespace-nowrap ${className ?? ''}`}>
    <i className="fa fa-diamond" style={{ color }} />
    <i className="fa fa-diamond" style={{ color }} />
    <i className="fa fa-diamond" style={{ color }} />
  </span>
);
